import { Circle, Triangle, X } from "lucide-react";
import type { ScheduleAvailability } from "@tabipla/shared/types";

interface AvailabilityIconProps {
  status: ScheduleAvailability;
  className?: string;
}

export function AvailabilityIcon({ status, className }: AvailabilityIconProps) {
  switch (status) {
    case "available":
      return <Circle className={`fill-green-500 text-green-500 ${className}`} />;
    case "maybe":
      return <Triangle className={`fill-yellow-500 text-yellow-500 ${className}`} />;
    case "unavailable":
      return <X className={`text-red-500 ${className}`} />;
  }
}
